import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Loader2 } from 'lucide-react';
import useSessionTimeout from './useSessionTimeout';

// Inner wrapper so the hook only mounts when the user is actually authenticated.
function AuthenticatedShell({ children }) {
  useSessionTimeout();
  return children;
}

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0d0e] text-white" data-testid="protected-loading">
        <Loader2 className="h-7 w-7 animate-spin text-[#4FBCC7]" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/app/login" replace state={{ from: location.pathname }} />;
  }
  return <AuthenticatedShell>{children}</AuthenticatedShell>;
}
